import type { ReactNode } from 'react';
import { Tooltip, mergeClasses } from '@fluentui/react-components';
import { WeatherMoonRegular, WeatherSunnyRegular } from '@fluentui/react-icons';
import { useBranding, type ThemePref } from '../theme/BrandingProvider';

/** CRT-/Terminal-Glyph für den Pip-Boy-Modus. */
function PipIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <rect x="2.5" y="4" width="19" height="13" rx="2" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M5.5 7.5h8M5.5 10h6M5.5 12.5h9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M9 20h6M12 17v3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

const OPTIONS: { key: ThemePref; label: string; icon: ReactNode }[] = [
  { key: 'light', label: 'Hell', icon: <WeatherSunnyRegular /> },
  { key: 'dark', label: 'Dunkel', icon: <WeatherMoonRegular /> },
  { key: 'pip', label: 'Pip-Boy', icon: <PipIcon /> },
];

/** Segmented Control im Header zum Umschalten des Erscheinungsbilds. */
export function ThemeSwitcher() {
  const { themePref, setThemePref } = useBranding();
  return (
    <div className="theme-seg" role="radiogroup" aria-label="Erscheinungsbild">
      {OPTIONS.map((o) => (
        <Tooltip key={o.key} relationship="label" content={o.label}>
          <button
            type="button"
            role="radio"
            aria-checked={themePref === o.key}
            aria-label={o.label}
            className={mergeClasses('theme-seg-btn', themePref === o.key && 'active')}
            onClick={() => setThemePref(o.key)}
          >
            {o.icon}
          </button>
        </Tooltip>
      ))}
    </div>
  );
}
